import { isArrayOf, isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { isMediaInfoRawData, MediaInfoRawData } from "./MediaInfo.js";


export type PlaylistName = string;

export interface MediaPlaylist<MI extends MediaInfoRawData<any>> {
    elements: MI[],
    name: PlaylistName,
    nextUrl?: string
}

export function isPlaylistName(a: any): a is PlaylistName {
    return isString(a);
}

export function isMediaPlaylist(obj: any): obj is MediaPlaylist<any> {
    return isObject(obj) &&
        hasOwnProperty(obj, 'elements') &&
        isArrayOf(obj['elements'], isMediaInfoRawData) &&
        hasOwnProperty(obj, 'name') &&
        isString(obj['name']);
}

